module.exports = __webpack_public_path__ + "img/CRT_Sword-004.ef98d2b5.png";